import Cleave from 'cleave.js';
export default Cleave;
//# sourceMappingURL=index.js.map